import { BreakpointObserver } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  OnInit,
} from '@angular/core';
import { BehaviorSubject, map, Observable, switchMap } from 'rxjs';
import { Breakpoints } from '../../../types/breakpoints';
import { LayoutDualColDrawerContentDirective } from './layout-dual-col-sections';

@Component({
    selector: 'lui-layout-dual-col',
    templateUrl: './layout-dual-col.component.html',
    styleUrls: ['./layout-dual-col.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutDualColComponent implements OnInit {
  @Input() sticky = false;
  @Input() wide!: boolean;
  @Input() asideIcon = 'summary_thin';
  @Input() asideTitle: string = $localize`Summary`;

  @Input() get defaultLayoutFrom() {
    return this.defaultLayoutFrom$.value;
  }
  set defaultLayoutFrom(value: Breakpoints) {
    this.defaultLayoutFrom$.next(value);
  }
  private defaultLayoutFrom$ = new BehaviorSubject<Breakpoints>(
    Breakpoints.GT_LG
  );

  isDefaultLayout$!: Observable<boolean>;

  @ContentChild(LayoutDualColDrawerContentDirective)
  drawerContentRef!: LayoutDualColDrawerContentDirective;

  constructor(private bpObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.isDefaultLayout$ = this.defaultLayoutFrom$.pipe(
      switchMap(() =>
        this.bpObserver
          .observe(this.defaultLayoutFrom)
          .pipe(map(({ matches }) => matches))
      )
    );
  }
}
